// extracted by css-extract-rspack-plugin
export default {"heading":"qh8aghfMBa8vQ8hP","truncate":"LABBtucsXl47rghI","small":"Og7yjqJY5MCKzrTz","medium":"lXMLjUQteW0xxMWd","large":"WOiEsIj1c1IFdP9O","bold":"nVNx1niODYNDTUH8"};